import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import {
  Spinner,
  Typography,
  LightButton,
  AccordionContained,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './styles/faq.css';
import { APP_TEXT } from '../const/app-text';
import { useGetFaqContent } from '../hooks/query/content-api/use-faq-content';

const componentText = APP_TEXT.components.faq;

interface FaqProps {
  showExitButton?: boolean;
  onExitButtonClicked?: () => void;
}

const Faq = ({ showExitButton, onExitButtonClicked }: FaqProps) => {
  const faqDataQuery = useGetFaqContent();

  const faqs = useMemo(() => {
    return (
      faqDataQuery?.data?.map((faqItem) => ({
        id: faqItem.id,
        header: faqItem.header,
        body: (
          <ReactMarkdown
            className={'markdown'}
            rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
          >
            {faqItem.body}
          </ReactMarkdown>
        ),
      })) ?? []
    );
  }, [faqDataQuery]);

  const renderLoading = (
    <div className="loadingWrapper">
      <Spinner aria-label="Loading FAQ information" />
    </div>
  );

  return (
    <div className="faqWrapper">
      <div className="content">
        <Typography
          variant="h2.bold"
          className="title"
        >
          {componentText.title}
        </Typography>

        {showExitButton && (
          <LightButton
            aria-label={componentText.close}
            icon="fa-solid fa-xmark"
            iconPos="left"
            onClick={() => onExitButtonClicked && onExitButtonClicked()}
          >
            {componentText.close}
          </LightButton>
        )}
      </div>
      {faqDataQuery.isLoading && renderLoading}
      {!faqDataQuery.isLoading && faqs?.length > 0 && <AccordionContained items={faqs} />}
    </div>
  );
};

export default Faq;
